export default __webpack_public_path__ + "static/media/Shape.0a4df976.svg";